/**
 * What the product is called, in the one place both ends can read.
 *
 * The rename from "Company Profiler" to Quarry was done in the browser and not
 * anywhere else, so the backend kept writing the old name into the `creator`
 * field of every workbook it exported — which is the copy that leaves the
 * building, attached to a file somebody sends a prospect. A constant in
 * components/Brand.tsx cannot be imported by a Lambda, so it lives here and
 * Brand.tsx re-exports it.
 */
export const PRODUCT_NAME = 'Quarry';
export const PARENT_NAME = 'HabileLabs';
/** For document metadata and anywhere else the parent has to be named too. */
export const PRODUCT_FULL_NAME = `${PRODUCT_NAME} by ${PARENT_NAME}`;
//# sourceMappingURL=brand.js.map